module.exports = __webpack_public_path__ + "img/1524651745.9af2b8d3.jpg";